<div class="bar-container" #under_bar>
    <div *ngIf="sector == 'homepage' && sitesService.siteSetting?.companyId else standardBar">
        <div class="under-bar-m" [style.background-color]="sectorColors?.activeBackground">
            <owl-carousel-o appOwlPreventClick  [options]="carouselOptions">
                <ng-template carouselSlide *ngFor="let sector of sectors"
                    [width]="sector.width || sector.chipWidth || 150">
                    <a appclick [routerLink]="['/',currentLang,'sector', sector?.seo?.slug]" class="category-link" [class.active]="currentPage == sector?.seo?.slug" (click)="sectorChange(sector)">
                        <div class="category-label block-subcategories__item cursor-pointers">
                            {{translateHelper.localize(sector.name)}}
                        </div>
                    </a>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>

    <ng-template #standardBar>
        <div class="categories-list">
            <button class="btn btn-primary" type="button" (click)="toggleSectors();" [ngClass]="{'submenu-open': sectorsOpen}">
                <div class="icon"><mat-icon>menu</mat-icon></div>
                <ng-container *ngIf="getSectorName(); else sectorsLabel">
                    <div class="label">{{translateHelper.localize(getSectorName())}}</div>
                </ng-container>
                <ng-template #sectorsLabel>
                    <div class="label">{{'all_sectors'|translate}}</div>
                </ng-template>
            </button>

            <div class="nav-links__submenu nav-links__submenu--type--megamenu" [ngClass]="{'nav-links__submenu--open': sectorsOpen}">
                <div class="megamenu">
                    <div class="megamenu__body">
                        <ng-container *ngFor="let sector of sectors">
                            <a appclick [routerLink]="['/',currentLang,'sector', sector?.seo?.slug]" class="category-link" [class.active]="currentPage == sector?.seo?.slug" (click)="sectorChange(sector)">
                                <div class="icon" *ngIf="sector.icon"><img [src]="sector.icon.url"></div>
                                <div class="title">{{translateHelper.localize(sector.name)}}</div>
                            </a>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="sector != 'homepage' && categories?.length > 0" class="under-bar-m" [style.background-color]="sectorColors?.activeBackground">
            <owl-carousel-o appOwlPreventClick *ngIf="categories && categories.length > 0" [options]="carouselOptions">
                <ng-template carouselSlide *ngIf="sitesService.features?.professionals && hasProfessionals" [width]="200">
                    <a appclick [routerLink]="['/', currentLang , 'sector', sector, 'professionals']">
                        <div class="btn professionals-link">
                            <div class="icon"><mat-icon>engineering</mat-icon></div>
                            <div class="label">{{'professionals'|translate}}</div>
                        </div>
                    </a>
                </ng-template>
                <ng-template carouselSlide *ngFor="let category of categories"
                    [width]="category.width || category.chipWidth || 150">
                    <a appclick [routerLink]="['/',currentLang,'sector', sector, 'category', category.seo?.slug]">
                        <div class="category-label block-subcategories__item cursor-pointers"
                            (click)="selectionChange(category)" [class.active]="selectedcategory == category?.seo?.slug"
                            [style.color]="sectorColors?.activeForeground">
                            {{translateHelper.localize(category.name)}}
                        </div>
                    </a>
                </ng-template>
            </owl-carousel-o>
        </div>
    </ng-template>


</div>


